import { useSelector } from "react-redux";
import { get } from "lodash";

// Canonical permission names. Keep in sync with the seeded catalog
// in server/migrations/versions/ea7877b41491_permission_and_user_permission.py.
// Settings-area access is not in this catalog — it is gated on the
// super_admin boolean (see useSuperAdmin() below).
export const PERMISSIONS = {
  MANAGEMENT_GENERAL_READ: "management.general.read",
  MANAGEMENT_GENERAL_WRITE: "management.general.write",
  MANAGEMENT_REVENUE_READ: "management.revenue.read",
  MANAGEMENT_REVENUE_WRITE: "management.revenue.write",
};

// Selector: returns the full user object from Redux.
const selectUser = (state) => get(state, "user.data", null);

// Pure helper for non-hook contexts (e.g. mapStateToProps).
// Server already expands write-implies-read into the `permissions` array.
export const hasPermission = (user, name) => {
  if (!user) return false;
  if (user.super_admin) return true;
  const perms = user.permissions || [];
  return perms.includes(name);
};

export const useUser = () => useSelector(selectUser);

export const usePermission = (name) => {
  const user = useUser();
  return hasPermission(user, name);
};

export const useSuperAdmin = () => {
  const user = useUser();
  return Boolean(user && user.super_admin);
};

// Render children only when the user has the named permission.
export const RequirePermission = ({ name, children, fallback = null }) => {
  const ok = usePermission(name);
  return ok ? children : fallback;
};
